/* eslint-disable no-unused-expressions */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import moment from 'moment';
import { makeStyles } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import _isEmpty from 'lodash/isEmpty';
import AddInfo from './AddInfo';
import PopupTopBar from '../../contests/components/PopupTopBar';
import PopupFooter from '../../contests/components/PopupFooter';
import service from '../../../apis/service';
import { apiEndpoints } from '../../../constants/apiEndpoints';
import useFetchData from '../hooks/useFetchData';
import { getStepOneData, getStepTwoDataDept, getStepTwoDataRule, validateStepOneData } from '../utils';
import { ErrorToast, notifySuccess } from '../../utils/Utils';
import { showProgress } from '../../../redux/actions/DealershipActions';
import Steps from '../../common/Steps';
import RoleMapping from './RoleMapping';

const createCustomStyles = (height) => ({
  content: {
    height: `${height}px`,
    width: '925px',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: '0px',
    display: 'flex',
    flexDirection: 'column',
    background: 'rgba(242, 244, 247, 1)',
    overflow: 'hidden',
  },
});

const useStyles = makeStyles(() => ({
  popupMainContainer: {
    background: 'rgba(242, 244, 247, 1)',
  },
}));
const JourneyAddNewPopup = ({ close, setSelectedIndex, journeyId }) => {
  const dispatch = useDispatch();
  const journeyDetails = useSelector((state) => state.JourneyDetails.journeydetails);
  const {
    fetchJourneysList,
    getJourneyDetail,
    getCollections,
    setMandatoryRuleCoditions,
    departments,
    rules,
    selectedRule,
    collectionList,
    mandatoryRuleCoditions,
    getTags,
  } = useFetchData();

  const classes = useStyles();
  const [assignType, setAssignType] = useState('department');
  const [step, setStep] = useState(1);
  const [data, setData] = useState({
    dueDate: moment().format('YYYY-MM-DD'),
    publishDate: moment().format('YYYY-MM-DD'),
    skillLevel: 0,
    isOEM: '0',
    collections: [],
  });

  useEffect(() => {
    if (journeyId) {
      getJourneyDetail(journeyId, false);
    } else {
      getCollections();
    }
    getTags();
  }, [journeyId, getJourneyDetail, getCollections, getTags]);

  useEffect(() => {
    if (journeyId && journeyDetails) {
      const hasAvPreview = journeyDetails?.avPreview && !_isEmpty(journeyDetails.avPreview);
      setData(() => ({
        journeyTitle: journeyDetails.title || '',
        journeyGoal: journeyDetails.goal || '',
        courseOverview: journeyDetails.description || '',
        skillLevel: journeyDetails.skillLevel === 'novice' ? 0 : journeyDetails.skillLevel === 'intermediate' ? 1 : 2,
        isOEM: journeyDetails?.isOEM ? '1' : '0',
        dueDate: journeyDetails?.dueDate || journeyDetails?.journeyMeta?.dueDate || '',
        publishDate: journeyDetails.publishDate || '',
        previewLink: hasAvPreview ? journeyDetails.avPreview?.url || '' : '',
        avPreview: hasAvPreview ? journeyDetails.avPreview : null, // Store full object for decryption
        thumbnail: journeyDetails.thumbnail || null,
        certificateBg: journeyDetails.certificate || null,
        courseCode: journeyDetails.courseCode || '',
        tags:
          journeyDetails.journeyTags?.map((tag) => ({
            title: tag.title,
            id: tag.id,
          })) || [],
        collections:
          journeyDetails.journeyCollections?.map((col) => ({
            label: col.title,
            value: col.id,
          })) || [],
      }));
    }
  }, [journeyDetails, journeyId]);

  const backBtn = () => setStep((prev) => prev - 1);
  const saveJourney = async () => {
    if (step === 1) {
      const isValid = validateStepOneData(data, !journeyId);
      if (!isValid) return;

      const formData = getStepOneData(data);
      try {
        if (!journeyId) {
          dispatch(showProgress(true));
          const res = await service.post(apiEndpoints.GET_JOURNEYS, formData);
          dispatch(showProgress(false));
          notifySuccess('Journey created successfully');
          setSelectedIndex(res?.id);
          fetchJourneysList();
          getJourneyDetail(res?.id, true);
          setStep((prev) => prev + 1);
        } else {
          dispatch(showProgress(true));
          const res = await service.put(apiEndpoints.JOURNEY_BY_ID.replace('ID', journeyId), formData);
          dispatch(showProgress(false));
          notifySuccess('Journey updated successfully');
          fetchJourneysList();
          getJourneyDetail(res?.id, false);
          setStep((prev) => prev + 1);
        }
      } catch (error) {
        ErrorToast(error);
        dispatch(showProgress(false));
      }
    } else {
      try {
        dispatch(showProgress(true));
        if (assignType === 'rule') {
          const processedData = getStepTwoDataRule(journeyDetails?.id, mandatoryRuleCoditions);
          await service.post(apiEndpoints.JOURNEY_ASSIGN_TO_RULE.replace('ID', data?.rule), processedData);
          notifySuccess('Role mapping completed successfully');
          close();
        } else {
          const processedData = getStepTwoDataDept(journeyDetails?.id, data);
          await service.post(apiEndpoints.JOURNEY_ASSIGN_TO_ROLE, processedData);
          notifySuccess('Role mapping completed successfully');
          close();
        }
        dispatch(showProgress(false));
      } catch (e) {
        ErrorToast(e);
        dispatch(showProgress(false));
        close();
      }
    }
  };
  return (
    <Modal isOpen onRequestClose={() => false} shouldCloseOnEsc={false} style={createCustomStyles('735')}>
      <div
        style={{
          flex: 1,
          overflowY: 'auto',
        }}
      >
        <PopupTopBar add={!journeyId} title="Journey" close={close} />
        <Steps step={step} stepInfo={['Journey Info', 'Role Mapping']} />
        {step === 1 && (
          <AddInfo
            data={data}
            setData={setData}
            className={classes.popupMainContainer}
            collectionList={collectionList}
          />
        )}
        {step === 2 && (
          <RoleMapping
            setData={setData}
            departmentData={departments}
            data={data}
            rules={rules}
            selectedRule={selectedRule}
            assignType={assignType}
            setAssignType={setAssignType}
            mandatoryRuleCoditions={mandatoryRuleCoditions}
            setMandatoryRuleCoditions={setMandatoryRuleCoditions}
          />
        )}
      </div>
      <PopupFooter add={!journeyId} backBtn={backBtn} saveContest={saveJourney} step={step} totalSteps={2} />
    </Modal>
  );
};

export default JourneyAddNewPopup;
